import { Eye, EyeOff } from 'lucide-react'
import { useState } from 'react'

import { t } from '@/shared/lib/i18n'

import { cn } from '@/shared/lib/utils'

import { Input } from '@/shared/ui/input'

interface PasswordInputProps extends React.ComponentProps<typeof Input> {
  disablePaste?: boolean
}

const PasswordInput = ({ disablePaste, className, ...props }: PasswordInputProps) => {
  const [visible, setVisible] = useState(false)

  return (
    <div className="relative">
      <Input
        type={visible ? 'text' : 'password'}
        className={cn('pr-10', className)}
        onCopy={disablePaste ? (event) => event.preventDefault() : undefined}
        onPaste={disablePaste ? (event) => event.preventDefault() : undefined}
        onCut={disablePaste ? (event) => event.preventDefault() : undefined}
        {...props}
      />
      <button
        type="button"
        tabIndex={-1}
        onClick={() => setVisible((current) => !current)}
        className="absolute inset-y-0 right-0 flex items-center px-3 text-muted-foreground hover:text-foreground"
        aria-label={
          visible ? t('common.passwordInput.hidePassword') : t('common.passwordInput.showPassword')
        }
      >
        {visible ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
      </button>
    </div>
  )
}

export { PasswordInput }
